import { apiFetch } from "../../../../toolympus/api/core";
import { createProvided } from "../../../../toolympus/components/primitives/createProvided";
import { useLoadedData } from "../../../../toolympus/hooks/useLoadedData"
import { OrgStructure } from "../types"


export const useOrgStructureData = () => {
  const data = useLoadedData<OrgStructure>(`/api/org/structure`, {
    chain_of_command: {},
    departments: [],
    employees: [],
  });

  const forceReload = async () => {
    const x = await apiFetch<OrgStructure>(`/api/org/structure?bypass-cache=true`);
    data.setData(x);
  }

  return {
    ...data,
    forceReload,
  };
}


const x = createProvided(
  useOrgStructureData, {
    data: {
      chain_of_command: {},
      departments: [],
      employees: [],
    },
    isLoading: false,
    reload: () => {},
    forceReload: () => { return Promise.resolve(); },
    setData: () => {},
  });

export const useOrgStructure = x.useValue;
export const OrgStructureProvider = x.Provider;

